import { render } from "./BoxIcon.vue?vue&type=template&id=40822572&scoped=true"
import script from "./BoxIcon.vue?vue&type=script&lang=js"
export * from "./BoxIcon.vue?vue&type=script&lang=js"

import "./BoxIcon.vue?vue&type=style&index=0&id=40822572&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-40822572"]])

export default __exports__